import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/legacy-src/lib/utils'

import { Slot, type SlotProps } from '@/src/domains/design-system/components/Slot'

const textVariants = cva('mb-0', {
  variants: {
    variant: {
      base: 'text-base tracking-[0.016em]',
      // Custom type with no relation in Figma DS
      xxs: 'text-[0.625rem] leading-[0.875rem] tracking-[0.016em]',
      xs: 'text-xs tracking-[0.016em]',
      sm: 'text-sm tracking-[0.016em]',
      lg: 'text-lg tracking-[0.016em]',
      xl: 'text-xl tracking-[0.016em]',
      'button-l': 'text-base/5 tracking-[0.046em]',
      'button-m': 'text-sm/5 tracking-[0.036em]',
      'button-s': 'text-xs/4 tracking-[0.036em]',
    },
    family: {
      serif: 'font-serif',
      sans: 'font-sans',
    },
    weight: {
      regular: 'font-normal',
      bold: 'font-bold',
      semibold: 'font-semibold',
    },
  },
  defaultVariants: { variant: 'base', weight: 'regular', family: 'sans' },
})

type TextVariantsProps = VariantProps<typeof textVariants>

export type TextProps = SlotProps<
  | 'p'
  | 'span'
  | 'div'
  | 'strong'
  | 'label'
  | 'sup'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'address'
  | 'dt'
  | 'dd'
  | 'li'
  | 'ul'
> &
  TextVariantsProps & {
    className?: string
  }

export const Text = (props: TextProps) => {
  const { variant, weight, family, ...rest } = props
  const className = textVariants({ variant, weight, family })

  return <Slot {...rest} className={cn(className, rest.className)} />
}
